@if (data && data.Id && data.Id > 0) {
  <app-search [data]="data"></app-search>
}
